function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_material-more-vert",
  "data-name": "Icon material-more-vert",
  d: "M18.311,12.623A3.311,3.311,0,1,0,15,9.311,3.321,3.321,0,0,0,18.311,12.623Zm0,3.311a3.311,3.311,0,1,0,3.311,3.311A3.321,3.321,0,0,0,18.311,15.934Zm0,9.934a3.311,3.311,0,1,0,3.311,3.311A3.321,3.321,0,0,0,18.311,25.869Z",
  transform: "translate(-15 -6)",
  fill: "#fff"
});

var SvgIconmaterialMoreVert = function SvgIconmaterialMoreVert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6.623,
    height: 26.491,
    viewBox: "0 0 6.623 26.491",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconmaterialMoreVert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon material-more-vert.d2ffb98b.svg";
export { ForwardRef as ReactComponent };